import { isEventPassSoldOut } from "@/lib/availability";

/** Ticket types share the occurrence's seats; a basket is not a sell-out. */
export function bookingPassAvailability(input: {
  passRemaining: number | null;
  occurrenceRemaining: number | null;
  attendeesPerPass: number;
  selectedPassSeats: number;
  selectedOccurrenceSeats: number;
  claimedHoldSeats: number;
}) {
  const passRemaining =
    input.passRemaining === null
      ? null
      : Math.max(input.passRemaining + input.claimedHoldSeats, 0);
  const occurrenceRemaining =
    input.occurrenceRemaining === null
      ? null
      : Math.max(input.occurrenceRemaining + input.claimedHoldSeats, 0);
  const remainingForPass =
    passRemaining === null
      ? null
      : Math.max(passRemaining - input.selectedPassSeats, 0);
  const remainingForOccurrence =
    occurrenceRemaining === null
      ? null
      : Math.max(occurrenceRemaining - input.selectedOccurrenceSeats, 0);
  const remaining =
    remainingForPass === null
      ? remainingForOccurrence
      : remainingForOccurrence === null
        ? remainingForPass
        : Math.min(remainingForPass, remainingForOccurrence);
  const soldOut = isEventPassSoldOut(
    { remaining: passRemaining, attendeesPerPass: input.attendeesPerPass },
    occurrenceRemaining,
  );
  const canAdd = remaining === null || remaining >= input.attendeesPerPass;
  return {
    soldOut,
    canAdd,
    label:
      !soldOut && !canAdd
        ? remaining === 0
          ? "All spots selected"
          : "Not enough spots for another ticket"
        : remaining === null
          ? null
          : `${remaining} left`,
  };
}
